import React, { useState } from 'react';
import I18n from '@/modules/i18n';
import FullWidthCard from '@/components/shared/NewLessonOverview/Cards/Card/FullWidthCard';
import LegacyAssignButton from '@/components/shared/LessonOverview/Cards/AssignButton';
import { unitSlideShowInitialValues } from '@/components/shared/NewLessonOverview/Cards/utils';
import assignedIcon from 'images/icons/assigned.svg';
import calendarPlusIcon from 'images/icons/calendar-plus.svg';
import { present_mode_shared_slide_show_path } from '@/modules/routes';
import StandardsPillGroup from '@/components/shared/StandardsPills/StandardsPillGroup';
import Icon from './Icon';
import type { SlideShow } from './UnitSlideShowCardTypes';

interface UnitSlideShowCardProps {
  overviewColor: string;
  programId: number;
  slideShow: SlideShow;
  stafferId?: number;
  unitId: number;
}

const UnitSlideShowCard = ({ overviewColor, programId, slideShow, stafferId, unitId }: UnitSlideShowCardProps) => {
  const title = I18n.locale === 'es' && slideShow.title_es ? slideShow.title_es : slideShow.title_en;
  const text = slideShow.unit_type === 'advanced_unit_project' ? `${I18n.t('advanced_unit_project')}: ${title}` : title;
  const presentPath = present_mode_shared_slide_show_path(slideShow.id, {
    from: 'Unit',
    parent_id: unitId,
    parent_type: 'Unit',
    program_id: programId,
    starting_slide: slideShow.starting_slide,
  });

  const canAssign = !!stafferId && !!slideShow.assignable?.[0] && !!slideShow.model_type;
  const [isAssigned, setIsAssigned] = useState(!!slideShow.is_assigned);

  const assignButton = canAssign ? (
    <LegacyAssignButton
      circle
      initialIsUnit
      handlePostSave={() => setIsAssigned(true)}
      initialValues={unitSlideShowInitialValues(slideShow)}
      isAssigned={isAssigned}
      lessonId={unitId}
      program={{ id: programId }}
      stafferId={stafferId}
    >
      <img
        aria-hidden
        alt=""
        className="tw-w-[26px] tw-h-[26px]"
        src={isAssigned ? assignedIcon : calendarPlusIcon}
      />
    </LegacyAssignButton>
  ) : null;

  return (
    <FullWidthCard
      openInNewWindow
      actionBarChildren={assignButton}
      icon={(
        <Icon className="tw-text-tci-black" slideShow={slideShow} />
      )}
      isStaffer={false}
      page={slideShow.page}
      presentPath={presentPath}
      programColor={overviewColor}
      title={text}
      titleAdjacent={(
        <StandardsPillGroup
          fitOnOneLine
          className="tw-my-auto tw-pl-2"
          heading={I18n.t('standards_correlation_for_this_activity')}
          locale={I18n.locale}
          standards={slideShow.standards ?? []}
        />
      )}
    />
  );
};

export default UnitSlideShowCard;
